export const AVATAR_PALETTE_SIZE = 6

const LETTER = /\p{L}/u

export function avatarColorIndex(name: string): number {
  let hash = 0
  for (const char of name) {
    hash = (Math.imul(hash, 31) + (char.codePointAt(0) ?? 0)) >>> 0
  }
  return hash % AVATAR_PALETTE_SIZE
}

function upperRune(char: string): string {
  const upper = char.toUpperCase()
  return Array.from(upper).length === 1 ? upper : char
}

function firstLetter(word: string): string | null {
  for (const char of word) {
    if (LETTER.test(char)) {
      return upperRune(char)
    }
  }
  return null
}

export function avatarInitials(name: string): string {
  const fields = name.split(/\s+/u).filter((field) => field.length > 0)
  const letters = fields.map(firstLetter).filter((letter): letter is string => letter !== null)
  const [first, second] = letters
  if (first === undefined) {
    return '?'
  }
  if (second !== undefined) {
    return `${first}${second}`
  }
  const [, secondRune] = Array.from(fields[0] ?? '')
  if (secondRune !== undefined && LETTER.test(secondRune)) {
    return `${first}${upperRune(secondRune)}`
  }
  return first
}
